import { useTheme } from '../../../contexts/ThemeContext';
import { useLanguage } from '../../../contexts/LanguageContext';
import { bookPageStrings } from '../../../strings/bookPageStrings';

export default function MessageBanner({
  type = 'info', // 'error', 'success', 'info', 'warning'
  message,
  onClose
}) {
  const { theme } = useTheme();
  const { language } = useLanguage();
  const strings = bookPageStrings[language];
  const isDark = theme === 'dark';

  if (!message) return null;

  const configs = {
    error: {
      bgClass: isDark ? 'bg-red-900/30 border-red-600' : 'bg-red-50 border-red-300',
      iconColor: isDark ? 'text-red-600' : 'text-red-500',
      textColor: isDark ? 'text-red-200' : 'text-red-700',
      icon: (
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
      )
    },
    success: {
      bgClass: isDark ? 'bg-green-900/30 border-green-600' : 'bg-green-50 border-green-300',
      iconColor: isDark ? 'text-green-600' : 'text-green-500',
      textColor: isDark ? 'text-green-200' : 'text-green-700',
      icon: (
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
      )
    },
    info: {
      bgClass: isDark ? 'bg-blue-900/30 border-blue-600' : 'bg-blue-50 border-blue-300',
      iconColor: isDark ? 'text-blue-400' : 'text-blue-500',
      textColor: isDark ? 'text-blue-200' : 'text-blue-700',
      icon: (
        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
      )
    },
    warning: {
      bgClass: isDark ? 'bg-yellow-900/30 border-yellow-600' : 'bg-yellow-50 border-yellow-300',
      iconColor: isDark ? 'text-yellow-400' : 'text-yellow-500',
      textColor: isDark ? 'text-yellow-200' : 'text-yellow-700',
      icon: (
        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
      )
    }
  };

  const config = configs[type] || configs.info;

  return (
    <div className={`mb-6 p-4 ${config.bgClass} border-2 rounded-xl ${isDark ? '' : 'shadow-sm'}`}>
      <div className="flex items-start">
        <svg className={`w-5 h-5 mr-3 mt-0.5 ${config.iconColor} flex-shrink-0`} fill="currentColor" viewBox="0 0 20 20">
          {config.icon}
        </svg>
        <div className="flex-1">
          <span className={`${config.textColor} font-medium`}>{message}</span>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className={`ml-3 flex-shrink-0 ${config.iconColor} hover:opacity-70 transition-opacity`}
            aria-label="Close"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
